export const CLUSTER_WORKSPACE_EDIT_BASIC_INFO_MODULE = "editBasicInfo";
export const CLUSTER_WORKSPACE_EDIT_CLUSTERS_MODULE = "editClusters";
export const DELETE_CLUSTER_WORKSPACE_FORM_MODULE = "deleteClusterWorkspace";
export const SCHEDULE_CLUSTER_WORKSPACE_BACKUPS_MODULE =
  "clusterWorkspaceBackups";
export const CLUSTER_GROUP_EDIT_CLUSTERS_CONFIG_MODULE = "editClustersConfig";
